import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';
import { GenerateEmbedUrlDisputeManagementRequest } from 'vopay';
const { api } = vopayApi;

export default function useGenerateEmbedUrlDisputeManagement() {
  const source = axios.CancelToken.source();
  const [link, setLink] = useState<string>();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function generateEmbedUrl(requestParams: GenerateEmbedUrlDisputeManagementRequest) {
    try {
      setDataFetchingInfo(true);

      const res = await api.generateEmbedUrlDisputeManagement(requestParams, source);
      setLink(res.Link);

      return res;
    } finally {
      setDataFetchingInfo(false);
    }
  }

  return {
    link,
    generateEmbedUrl,
  };
}
